module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAANlBMVEUAAABVVVVAQEBhYWRgY2ZgYmVgY2ViYmZiYmZhY2ViYmZiYmVhY2VhY2ZhYmViYmZiY2ZiY2YXc/2HAAAAEXRSTlMAAwRUVWBicHN0dY2OjqmqqtZQNYMAAABJSURBVDjL7ZIxEoAgEMQOFEU9PPL/z1rbLC3jmDaZrdZsItJ5JBlUiKyCDbjlhv/FiwbswucAysD7h33X3ipwDT7p+vfrYrPyAMESBpsD5Bg5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right.png
// module id = vC+O
// module chunks = 1